import React, { useState, useEffect } from 'react';
import { TextField } from '@mui/material';

interface OptimizedTextFieldProps {
  value?: string;
  onChange?: (value: string) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  debounceTime?: number;
  [key: string]: any;
}

export const OptimizedTextField: React.FC<OptimizedTextFieldProps> = React.memo(({ 
  value = '', 
  onChange,
  onBlur,
  debounceTime = 50,
  ...props 
}) => {
  const [localValue, setLocalValue] = useState(value);
  
  useEffect(() => {
    if (onChange) {
      const timeoutId = setTimeout(() => {
        if (localValue !== value) {
          onChange(localValue);
        }
      }, debounceTime);
      
      return () => clearTimeout(timeoutId);
    }
  }, [localValue, debounceTime, onChange, value]);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (localValue !== value && onChange) {
      onChange(localValue);
    }
    
    if (onBlur) {
      onBlur(e);
    }
  };

  return (
    <TextField
      value={localValue}
      onChange={handleChange}
      onBlur={handleBlur}
      {...props}
    />
  );
});